import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/category'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  edit(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  add(category) {
    return http.post(`${resource}`, category, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  update(category, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, category, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
